<div *ngIf="personalDataForm" [formGroup]="personalDataForm">
  <!-- Mesure de protection juridique -->
  <div class="row">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Mesure de protection juridique </strong>
      </p>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start required">Le jeune est-il sous tutelle ou curatelle ?</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="underSupervisionYes"
          type="radio"
          class="form-check-input"
          formControlName="underSupervision"
          name="underSupervision"
          [class.is-invalid]="submitted && personalDataForm.controls.underSupervision.invalid"
          [value]="true"
        />
        <label for="underSupervisionYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="underSupervisionNo"
          type="radio"
          class="form-check-input"
          formControlName="underSupervision"
          name="underSupervision"
          [class.is-invalid]="submitted && personalDataForm.controls.underSupervision.invalid"
          [value]="false"
        />
        <label for="underSupervisionNo" class="form-check-label">Non</label>
      </div>
    </div>
    <small *ngIf="submitted && personalDataForm.controls.underSupervision.errors?.required" class="form-text text-danger ms-3"
      >Ce champ est requis.</small
    >
  </div>
  <div class="row">
    <div class="mb-3 text-secondary col-12 col-xl-6">
      <label [class.required]="personalDataForm.controls.underSupervision.value === true">Jugement</label>
      <app-file-input
        formControlName="supervisionDocument1"
        [beneficiary]="beneficiary"
        [invalid]="
          personalDataForm.controls.supervisionDocument1.errors?.fileSize ||
          personalDataForm.controls.supervisionDocument1.errors?.fileType ||
          (submitted && personalDataForm.controls.supervisionDocument1?.errors)
        "
        title="jugement"
        titleId="52"
        accept="application/pdf,image/png,image/jpeg"
        [maxFileSize]="maxFileSize"
      ></app-file-input>
      <small *ngIf="submitted && personalDataForm.controls.supervisionDocument1.errors?.required" class="form-text text-danger"
        >Le jugement est requis.</small
      >
      <small *ngIf="personalDataForm.controls.supervisionDocument1.errors?.fileSize" class="form-text text-danger">
        Le document ne doit pas dépasser {{ maxFileSizeStr }}.
      </small>
      <small *ngIf="personalDataForm.controls.supervisionDocument1.errors?.fileType" class="form-text text-danger"
        >Le document doit être de type PDF, PNG ou JPG.</small
      >
    </div>
    <div class="mb-3 text-secondary col-12 col-xl-6">
      <label>Autorisation du tuteur ou du curateur</label>
      <app-file-input
        formControlName="supervisionDocument2"
        [beneficiary]="beneficiary"
        [invalid]="personalDataForm.controls.supervisionDocument2.errors?.fileSize || personalDataForm.controls.supervisionDocument2.errors?.fileType"
        title="autorisation_tuteur"
        titleId="53"
        accept="application/pdf,image/png,image/jpeg"
        [maxFileSize]="maxFileSize"
      ></app-file-input>
      <small *ngIf="personalDataForm.controls.supervisionDocument2.errors?.fileSize" class="form-text text-danger">
        Le document ne doit pas dépasser {{ maxFileSizeStr }}.
      </small>
      <small *ngIf="personalDataForm.controls.supervisionDocument2.errors?.fileType" class="form-text text-danger"
        >Le document doit être de type PDF, PNG ou JPG.</small
      >
    </div>
  </div>
  <!-- Situation familiale -->
  <div class="row">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Situation familiale </strong>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="mb-3 text-secondary col-12 col-lg-5">
      <label>Situation familiale</label>
      <select class="form-select" formControlName="maritalStatus">
        <option value=""></option>
        <option *ngIf="personalDataForm.controls.maritalStatus.value" [ngValue]="personalDataForm.controls.maritalStatus.value">
          {{ MaritalStatus[personalDataForm.controls.maritalStatus.value] }}
        </option>
      </select>
    </div>
    <div class="mb-3 text-secondary col-12 col-lg-5" *ngIf="showPartnerOnRsa">
      <label>Conjoint(e) bénéficiaire du RSA ?</label>
      <div class="row justify-content-start my-2">
        <div class="col-3">
          <div class="form-check form-check-inline">
            <input id="partnerOnRsaYes" type="radio" class="form-check-input" formControlName="partnerOnRsa" name="partnerOnRsa" [value]="true" />
            <label for="partnerOnRsaYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-3">
          <div class="form-check form-check-inline">
            <input id="partnerOnRsaNo" type="radio" class="form-check-input" formControlName="partnerOnRsa" name="partnerOnRsa" [value]="false" />
            <label for="partnerOnRsaNo" class="form-check-label">Non</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="mb-3 text-secondary col-12 col-lg-5">
      <label class="float-start">Nombre de personnes à charge</label>
      <input type="text" class="form-control" formControlName="dependentsNumber" />
    </div>
  </div>
  <div class="row">
    <div class="mb-3 col-12">
      <div class="row">
        <div class="col-12 col-lg-5">
          <label>Grossesse en cours ? (+3 mois, valable pour le conjoint)</label>
        </div>
        <div class="col-12 col-lg-7">
          <div class="form-check form-check-inline">
            <input id="pregnancyYes" type="radio" class="form-check-input" formControlName="pregnancy" name="pregnancy" [value]="true" />
            <label for="pregnancyYes" class="form-check-label">Oui</label>
          </div>
          <div class="form-check form-check-inline">
            <input id="pregnancyNo" type="radio" class="form-check-input" formControlName="pregnancy" name="pregnancy" [value]="false" />
            <label for="pregnancyNo" class="form-check-label">Non</label>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 col-12">
      <div class="row align-items-center">
        <div class="col-12 col-lg-5">
          <label>Avez-vous déjà fait une simulation de RSA ?</label>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-check form-check-inline">
            <input id="rsaSimulationYes" type="radio" class="form-check-input" formControlName="rsaSimulation" name="rsaSimulation" [value]="true" />
            <label for="rsaSimulationYes" class="form-check-label">Oui</label>
          </div>
          <div class="form-check form-check-inline">
            <input id="rsaSimulationNo" type="radio" class="form-check-input" formControlName="rsaSimulation" name="rsaSimulation" [value]="false" />
            <label for="rsaSimulationNo" class="form-check-label">Non</label>
          </div>
        </div>
        <div class="mb-3 col-12 col-lg-4 mb-0 text-secondary">
          <label>Commentaire</label>
          <input type="text" class="form-control" formControlName="rsaSimulationComment" />
        </div>
      </div>
    </div>
    <div class="mb-3 col-12">
      <div class="row">
        <div class="col-12 col-lg-5">
          <label>Parent(s) bénéficiaire(s) du RSA ?</label>
        </div>
        <div class="col-12 col-lg-7">
          <div class="form-check form-check-inline">
            <input id="parentsOnRsaYes" type="radio" class="form-check-input" formControlName="parentsOnRsa" name="parentsOnRsa" [value]="true" />
            <label for="parentsOnRsaYes" class="form-check-label">Oui</label>
          </div>
          <div class="form-check form-check-inline">
            <input id="parentsOnRsaNo" type="radio" class="form-check-input" formControlName="parentsOnRsa" name="parentsOnRsa" [value]="false" />
            <label for="parentsOnRsaNo" class="form-check-label">Non</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Situation fiscale -->
  <div class="row">
    <div class="col-12 col-lg-12">
      <label class="required"><strong> Situation fiscale </strong></label>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-check form-check-inline">
        <input
          id="detachedFromParents"
          type="radio"
          class="form-check-input"
          formControlName="taxSituation"
          name="taxSituation"
          value="DetachedFromParents"
          [class.is-invalid]="submitted && personalDataForm.controls.taxSituation.errors"
        />
        <label for="detachedFromParents" class="form-check-label">Constitue son propre foyer fiscal</label>
      </div>
    </div>
    <div class="col-12">
      <div class="form-check form-check-inline">
        <input
          id="familyBreakdown"
          type="radio"
          class="form-check-input"
          formControlName="taxSituation"
          name="taxSituation"
          value="FamilyBreakdown"
          [class.is-invalid]="submitted && personalDataForm.controls.taxSituation.errors"
        />
        <label for="familyBreakdown" class="form-check-label">Rattaché au foyer fiscal des parents mais en rupture familiale</label>
      </div>
    </div>
    <div class="col-12">
      <div class="form-check form-check-inline">
        <input
          id="parentsWithLimitedQuotient"
          type="radio"
          class="form-check-input"
          formControlName="taxSituation"
          name="taxSituation"
          value="ParentsWithLimitedQuotient"
          [class.is-invalid]="submitted && personalDataForm.controls.taxSituation.errors"
        />
        <label for="parentsWithLimitedQuotient" class="form-check-label"
          >Rattaché au foyer fiscal des parents dont le quotient familial est inférieur ou égal à 800</label
        >
      </div>
    </div>
    <div class="col-12">
      <div class="form-check form-check-inline">
        <input
          id="noSupportFromPartner"
          type="radio"
          class="form-check-input"
          formControlName="taxSituation"
          name="taxSituation"
          value="NoSupportFromPartner"
          [class.is-invalid]="submitted && personalDataForm.controls.taxSituation.errors"
        />
        <label for="noSupportFromPartner" class="form-check-label"
          >Constituant un foyer fiscal de couple dont le quotient familial est inférieur ou égal à 800</label
        >
      </div>
    </div>
    <div class="col-12 mb-2">
      <small *ngIf="submitted && personalDataForm.controls.taxSituation.errors?.required" class="form-text text-danger"
        >La situation fiscale est obligatoire</small
      >
    </div>
    <ng-container [ngSwitch]="taxSituationCase">
      <ng-container *ngSwitchCase="1"
        ><div class="col-12">Détachement fiscal</div>
        <div class="col-12">
          <div class="form-check form-check-inline">
            <input id="conducted" type="radio" class="form-check-input" formControlName="taxDetachment" name="taxDetachment" value="Conducted" />
            <label for="conducted" class="form-check-label">Effectué (avis d'impôts disponible)</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-check form-check-inline">
            <input id="inProgress" type="radio" class="form-check-input" formControlName="taxDetachment" name="taxDetachment" value="InProgress" />
            <label for="inProgress" class="form-check-label">En cours (récépissé déclaration d'impôts)</label>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="2"
        ><div class="mb-3 text-secondary col-12">
          <label class="required">Merci d'expliciter la situation de rupture :</label>
          <textarea
            class="form-control"
            formControlName="breakupComment"
            [class.is-invalid]="submitted && personalDataForm.controls.breakupComment.invalid"
          ></textarea>
          <small *ngIf="submitted && personalDataForm.controls.breakupComment.errors?.required" class="form-text text-danger"
            >Ce champ est obligatoire</small
          >
        </div></ng-container
      >
      <ng-container *ngSwitchCase="3">
        <div class="col-7 col d-flex flex-row justify-content-around">
          <div class="mb-3 text-secondary">
            <label class="required">Quotient familial</label>
            <input
              type="text"
              class="form-control"
              formControlName="familyQuotient"
              appInputNumbersOnly
              [class.is-invalid]="submitted && personalDataForm.controls.familyQuotient.errors"
            />
            <small *ngIf="submitted && personalDataForm.controls.familyQuotient.errors?.required" class="form-text text-danger"
              >Le quotient familial est obligatoire</small
            >
          </div>
          <div class="mb-3 text-secondary">
            <label>N° CAF/MSA</label>
            <input
              type="text"
              class="form-control"
              formControlName="recipientNumber"
              appInputNumbersOnly
              [class.is-invalid]="submitted && personalDataForm.controls.recipientNumber.errors"
            />
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
